import request from '@/utils/request'

/** 获取用户待办列表 */
export const getUserTodoList = data => request.post('/user/todo', data)

/** 获取用户待办详情 */
export const getUserTodoDetail = id => request.get(`/user/todo/${id}`)

/** 批量处理用户待办 */
export const handleUserTodo = data => request.post('/user/todo/batch', data)

/** 创建用户评论 */
export const createTodoRecord = data => request.post('/user/todo/record', data)

/** 更新用户评论 */
export const updateTodoRecord = (id, data) => request.put(`/user/todo/record/${id}`, data)

/** 删除用户评论 */
export const deleteTodoRecord = id => request.delete(`/user/todo/record/${id}`)

/** 获取用户待办统计 */
export const getUserTodoStatics = () => request.get('/user/todo/statics')
